import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import CheckCSName from "../CheckCSName";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import SuperText from "../SuperText";
import ResultView from "../../../components/ResultView";
import {v4} from "uuid";

export function B40({data, message_key}) {
    const {settings} = useUser()
    let result = [...(data?.result || [])]
    result.reverse()

    return (
        <>
            {
                result.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables}/>
                    </ResultView>
                ))
            }
        </>
    )
}

export const BridgeTable = ({r}) => {
    return (
        <>
            <ResultTable >
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell rowSpan={2} style={{
                            width: HecRasHelper.getWidth(20),
                            textAlign: 'left',
                            verticalAlign: 'start'
                        }}>
                            Bridge<br/>
                            RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                        </ResultHeaderCell>
                        <ResultHeaderCell colSpan={2}>US</ResultHeaderCell>
                        <ResultHeaderCell colSpan={2}>DS</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10)
                        }}>Left</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10)
                        }}>Right</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10)
                        }}>Left</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            width: HecRasHelper.getWidth(10),
                        }}>Right</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <ResultRow>
                        <ResultBodyCell>Thalweg Sta</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.up_thalweg[0]?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.down_thalweg[0]?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Thalweg Elev</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.up_thalweg[1]?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.down_thalweg[1]?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Bank Sta</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_left?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_right?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_left?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_right?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Bank Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Ineff Sta</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.up_left_xs_footnote}/>
                            {r.up_left_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.up_right_xs_footnote}/>
                            {r.up_right_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.down_left_xs_footnote}/>
                            {r.down_left_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>
                            <SuperText text={r.down_right_xs_footnote}/>
                            {r.down_right_xs_station?.toString() || '-'}
                        </ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Ineff Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_left_xs_elevation?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_right_xs_elevation?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_left_xs_elevation?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_right_xs_elevation?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Opening Sta</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_left_opening_station?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.up_right_opening_station?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_left_opening_station?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r.down_right_opening_station?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Distance To XS</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{parseFloat(r?.dist_to_xs)?.toFixed(2) || '-'}</ResultBodyCell>
                        <ResultHeaderCell style={{color: 'orange', textAlign: 'right'}}
                                          colSpan={2}>{parseFloat(r?.down_dist)?.toFixed(2) || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Bridge Width</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={4}>{r?.bridge_us_width?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Dist. Btw XS</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={4}>{r?.up_dist_btw_xs?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Expansion Width</ResultBodyCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.up_left_diff?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.up_right_diff?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.down_left_diff?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            color: 'orange',
                            textAlign: 'right'
                        }}>{r?.down_right_diff?.toString() || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Low Chord Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_left_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.up_right_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_left_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.down_right_low_chord_elev?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>High Chord Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.ulr_high_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.urr_high_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.dlr_high_elev?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.drr_high_elev?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>High Chord Sta</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.ulr_high_sta?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.urr_high_sta?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.dlr_high_sta?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.drr_high_sta?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Top of Rail Elev</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.ulr_top_rail?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.urr_top_rail?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.dlr_top_rail?.toString() || '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.drr_top_rail?.toString() || '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Rail Height</ResultBodyCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.ulr_rail_height?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.urr_rail_height?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.dlr_rail_height?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.drr_rail_height?.toString() || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Cont/Exp Ratio</ResultBodyCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.up_left_ratio?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.up_right_ratio?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.down_left_ratio?.toString() || '-'}</ResultHeaderCell>
                        <ResultHeaderCell style={{
                            textAlign: 'right',
                            color: 'orange'
                        }}>{r?.down_right_ratio?.toString() || '-'}</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>Vertical Clearance</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.vc_us_left?.toFixed(2) ?? '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.vc_us_right?.toFixed(2) ?? '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.vc_ds_left?.toFixed(2) ?? '-'}</ResultBodyCell>
                        <ResultBodyCell
                            style={{textAlign: 'right'}}>{r?.vc_ds_right?.toFixed(2) ?? '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>US/DS Distance Min</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.auto_distance_us_min?.toFixed(2) ?? '-'}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.auto_distance_ds_min?.toFixed(2) ?? '-'}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultBodyCell>US/DS Distance Max</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.auto_distance_us_max?.toFixed(2) ?? '-'}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}
                                        colSpan={2}>{r?.auto_distance_ds_max?.toFixed(2) ?? '-'}</ResultBodyCell>
                    </ResultRow>
                </ResultBody>
            </ResultTable>
            <div>
                <ResultText>
                    Skew: {r?.skew}, Map Skew: {parseInt(r?.skew_map)}
                </ResultText>
            </div>
        </>
    )
}


export const CulvertTable = ({r}) => {
    const culverts = []
    r?.culverts?.forEach(c => {
        const barrels = []
        c?.barrels?.forEach(b => {
            barrels.push(
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>{b?.name} Centerline Sta</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{b?.us || '-'}</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{b?.ds || '-'}</ResultBodyCell>
                </ResultRow>
            )
        })

        culverts.push(
            <>
                <ResultRow>
                    <ResultHeaderCell colSpan={5}>{c?.name}</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>Distance To XS</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{parseFloat(c?.us_dist_to_xs)?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{parseFloat(c?.ds_dist_to_xs)?.toFixed(2) || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>Culvert Length</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={4}>{c?.culvert_length || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell style={{textAlign: 'start'}}>Invert Elev</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{c?.us_invert_elev || '-'}</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'end'}} colSpan={2}>{c?.ds_invert_elev || '-'}</ResultBodyCell>
                </ResultRow>
                {barrels}
            </>
        )
    })

    return (
        <ResultTable style={{maxWidth: HecRasHelper.getWidth(54)}}>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell rowSpan={2} style={{
                        width: HecRasHelper.getWidth(22),
                        textAlign: 'left',
                        verticalAlign: 'start'
                    }}>
                        Culvert Group<br/>
                        RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                    </ResultHeaderCell>
                    <ResultHeaderCell colSpan={2}>US</ResultHeaderCell>
                    <ResultHeaderCell colSpan={2}>DS</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Left</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Right</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Left</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        textAlign: 'right',
                        width: HecRasHelper.getWidth(8)
                    }}>Right</ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                <ResultRow>
                    <ResultBodyCell>Bank Sta</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_left?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_right?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_left?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_right?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Bank Elev</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.us_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_left_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.ds_bank_right_elev?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Ineff Sta</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.up_left_xs_footnote}/>
                        {r.up_left_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.up_right_xs_footnote}/>
                        {r.up_right_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.down_left_xs_footnote}/>
                        {r.down_left_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}>
                        <SuperText text={r.down_right_xs_footnote}/>
                        {r.down_right_xs_station?.toString() || '-'}
                    </ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Ineff Elev</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.up_left_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.up_right_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.down_left_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.down_right_xs_station_elev?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Opening Sta</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.us_left_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.us_right_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.ds_left_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r.ds_right_opening_sta?.toFixed(2) || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Dist. Btw XS</ResultBodyCell>
                    <ResultBodyCell style={{textAlign: 'right'}}
                                    colSpan={4}>{r?.us_dist_btw_xs?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Expansion Width</ResultBodyCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_left_diff?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_right_diff?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_left_diff?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_right_diff?.toString() || '-'}</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Cont/Exp Ratio</ResultBodyCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_left_ratio?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.up_right_ratio?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_left_ratio?.toString() || '-'}</ResultHeaderCell>
                    <ResultHeaderCell style={{
                        color: 'orange',
                        textAlign: 'right'
                    }}>{r?.down_right_ratio?.toString() || '-'}</ResultHeaderCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Lowest High Chord Elev</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.us_low_high_elev?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.ds_low_high_elev?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Lowest High Chord Sta</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.us_low_high_sta?.toString() || '-'}</ResultBodyCell>
                    <ResultBodyCell
                        colSpan={2}
                        style={{textAlign: 'right'}}>{r.ds_low_high_sta?.toString() || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Vertical Clearance</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.vc_us_left?.toFixed(2) ?? '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.vc_us_right?.toFixed(2) ?? '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.vc_ds_left?.toFixed(2) ?? '-'}</ResultBodyCell>
                    <ResultBodyCell
                        style={{textAlign: 'right'}}>{r?.vc_ds_right?.toFixed(2) ?? '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>US/DS Distance Min</ResultBodyCell>
                    <ResultBodyCell colSpan={2}
                                    style={{textAlign: 'right'}}>{r?.auto_distance_us_min?.toFixed(2) ?? '-'}</ResultBodyCell>
                    <ResultBodyCell colSpan={2}
                                    style={{textAlign: 'right'}}>{r?.auto_distance_ds_min?.toFixed(2) ?? '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>US/DS Distance Max</ResultBodyCell>
                    <ResultBodyCell colSpan={2}
                                    style={{textAlign: 'right'}}>{r?.auto_distance_us_max?.toFixed(2) ?? '-'}</ResultBodyCell>
                    <ResultBodyCell colSpan={2}
                                    style={{textAlign: 'right'}}>{r?.auto_distance_ds_max?.toFixed(2) ?? '-'}</ResultBodyCell>
                </ResultRow>
                {culverts}
            </ResultBody>
        </ResultTable>
    )
}

const formatSpans = (spans) => {
    if (!Array.isArray(spans) || spans.length === 0) return '-'
    return spans.join(', ')
}

const formatAbutSlope = (value) => {
    // Backend now reports a single significant slope per side. Older cached
    // results may still carry an array of per-segment slopes — fall back to the
    // last segment for those so historical tables keep rendering.
    let v = value
    if (Array.isArray(v)) {
        const nums = v.filter(s => s !== null && s !== undefined && !isNaN(s))
        v = nums.length > 0 ? nums[nums.length - 1] : null
    }
    if (v === null || v === undefined || isNaN(v)) return '-'
    return `${v?.toFixed?.(1) ?? v}:1`
}

const formatPierShape = (r) => {
    // Pier yoksa Pier Shape (size) "-" gosterilir (pier_shape_name dolu olsa bile).
    if (!r?.piers_us || r.piers_us.length === 0) return '-'
    const sizes = (r?.piers_us || []).map(p => p?.width).filter(w => w !== null && w !== undefined)
    const suffix = sizes.length > 0 ? ` (${sizes.join(', ')})` : ''
    return `${r?.pier_shape_name || '-'}${suffix}`
}

export const BridgeInfoTable = ({r}) => {
    return (
        <ResultTable>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell colSpan={3} style={{textAlign: 'left'}}>
                        Bridge RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                    </ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                <ResultRow>
                    <ResultBodyCell style={{width: HecRasHelper.getWidth(24)}}>Description</ResultBodyCell>
                    <ResultBodyCell colSpan={2}>{r?.description || '-'}</ResultBodyCell>
                </ResultRow>
                {r?.ncdot_bridge_id !== undefined && (
                    <ResultRow>
                        <ResultBodyCell>NCDOT Bridge ID</ResultBodyCell>
                        <ResultBodyCell colSpan={2}>
                            {r.ncdot_bridge_id === 'No match'
                                ? <span style={{color: '#999', fontStyle: 'italic'}}>No match</span>
                                : r.ncdot_bridge_id}
                        </ResultBodyCell>
                    </ResultRow>
                )}
                {r?.roadway && (
                    <ResultRow>
                        <ResultBodyCell>Roadway</ResultBodyCell>
                        <ResultBodyCell colSpan={2}>{r.roadway}</ResultBodyCell>
                    </ResultRow>
                )}
                <ResultRow>
                    <ResultBodyCell>Width</ResultBodyCell>
                    <ResultBodyCell colSpan={2}>{r?.bridge_us_width ?? '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Span Width US/DS</ResultBodyCell>
                    <ResultBodyCell style={{width: HecRasHelper.getWidth(20)}}>{formatSpans(r?.span_widths_us)}</ResultBodyCell>
                    <ResultBodyCell style={{width: HecRasHelper.getWidth(20)}}>{formatSpans(r?.span_widths_ds)}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Pier Shape (size)</ResultBodyCell>
                    <ResultBodyCell colSpan={2}>{formatPierShape(r)}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell rowSpan={2} style={{verticalAlign: 'top'}}>Abutment Slopes (H:V)</ResultBodyCell>
                    <ResultBodyCell>{formatAbutSlope(r?.abutment_slopes_us?.left)}</ResultBodyCell>
                    <ResultBodyCell>{formatAbutSlope(r?.abutment_slopes_us?.right)}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>{formatAbutSlope(r?.abutment_slopes_ds?.left)}</ResultBodyCell>
                    <ResultBodyCell>{formatAbutSlope(r?.abutment_slopes_ds?.right)}</ResultBodyCell>
                </ResultRow>
            </ResultBody>
        </ResultTable>
    )
}

export const CulvertInfoTable = ({r}) => {
    return (
        <ResultTable>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell colSpan={2} style={{textAlign: 'left'}}>
                        Culvert RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                    </ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                <ResultRow>
                    <ResultBodyCell style={{width: HecRasHelper.getWidth(20)}}>Description</ResultBodyCell>
                    <ResultBodyCell>{r?.description || '-'}</ResultBodyCell>
                </ResultRow>
                {
                    r?.culverts?.map(c => {
                        const spanXRise = (c?.span != null && c?.rise != null) ? `${c.span}x${c.rise}` : '-'
                        return (
                            <>
                                <ResultRow>
                                    <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{c?.name}</ResultHeaderCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultBodyCell>Shape</ResultBodyCell>
                                    <ResultBodyCell>{c?.shape || '-'}</ResultBodyCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultBodyCell>Length</ResultBodyCell>
                                    <ResultBodyCell>{c?.culvert_length ?? '-'}</ResultBodyCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultBodyCell>Span x Rise</ResultBodyCell>
                                    <ResultBodyCell>{spanXRise}</ResultBodyCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultBodyCell>Chart #</ResultBodyCell>
                                    <ResultBodyCell>{c?.chart_name || '-'}</ResultBodyCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultBodyCell>Scale #</ResultBodyCell>
                                    <ResultBodyCell>{c?.scale_name || '-'}</ResultBodyCell>
                                </ResultRow>
                            </>
                        )
                    })
                }
            </ResultBody>
        </ResultTable>
    )
}

export const InlineStructureInfoTable = ({r}) => {
    return (
        <ResultTable>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell colSpan={2} style={{textAlign: 'left'}}>
                        Inline Structure RS <CheckCSName csName={r.cross_section} csNameVal={r.cross_section} />
                    </ResultHeaderCell>
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                <ResultRow>
                    <ResultBodyCell style={{width: HecRasHelper.getWidth(20)}}>Description</ResultBodyCell>
                    <ResultBodyCell>{r?.description || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Width</ResultBodyCell>
                    <ResultBodyCell>{r?.width ?? '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Weir Crest Shape</ResultBodyCell>
                    <ResultBodyCell>{r?.weir_crest_shape || '-'}</ResultBodyCell>
                </ResultRow>
                <ResultRow>
                    <ResultBodyCell>Weir Coef</ResultBodyCell>
                    <ResultBodyCell>{r?.weir_coef ?? '-'}</ResultBodyCell>
                </ResultRow>
                {
                    r?.gates?.map((g, idx) => (
                        <>
                            <ResultRow>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{g?.gate_name || `Gate #${idx + 1}`}</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Gate Type</ResultBodyCell>
                                <ResultBodyCell>{g?.gate_type ?? '-'}</ResultBodyCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Discharge Coef</ResultBodyCell>
                                <ResultBodyCell>{g?.discharge_coef ?? '-'}</ResultBodyCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Weir Shape</ResultBodyCell>
                                <ResultBodyCell>{g?.weir_shape || '-'}</ResultBodyCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Weir Coef</ResultBodyCell>
                                <ResultBodyCell>{g?.weir_coef ?? '-'}</ResultBodyCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Height</ResultBodyCell>
                                <ResultBodyCell>{g?.height ?? '-'}</ResultBodyCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Width</ResultBodyCell>
                                <ResultBodyCell>{g?.width ?? '-'}</ResultBodyCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultBodyCell>Invert</ResultBodyCell>
                                <ResultBodyCell>{g?.invert ?? '-'}</ResultBodyCell>
                            </ResultRow>
                        </>
                    ))
                }
            </ResultBody>
        </ResultTable>
    )
}

// Statik leaflet popup'i (renderToString) icin CSS-only sekmeler. antd Tabs
// burada calismaz (React handler yok), bu yuzden gizli radio + label + sibling
// selector ile JS'siz sekme gecisi saglanir. Yapi map popup'inda INF 01 / INF 02
// tablolarini ayni str_table verisinden gosterir.
export const StructureInfoTabs = ({inf01, inf02, label1 = 'INF 01', label2 = 'INF 02'}) => {
    const id = v4().replace(/-/g, '')
    const css = `
.stbs-${id} > input{display:none}
.stbs-${id} > label{display:inline-block;padding:3px 12px;cursor:pointer;border:1px solid #d9d9d9;border-bottom:none;margin-right:2px;background:#fafafa;border-radius:4px 4px 0 0;font-size:12px}
.stbs-${id} > #t1-${id}:checked ~ label[for="t1-${id}"],
.stbs-${id} > #t2-${id}:checked ~ label[for="t2-${id}"]{background:#fff;font-weight:bold;border-bottom:2px solid #1677ff;margin-bottom:-1px}
.stbs-${id} > .panel{display:none;border:1px solid #d9d9d9;padding:8px;overflow:auto}
.stbs-${id} > #t1-${id}:checked ~ .panel-1{display:block}
.stbs-${id} > #t2-${id}:checked ~ .panel-2{display:block}
`
    return (
        <div className={`stbs-${id}`}>
            <style dangerouslySetInnerHTML={{__html: css}}/>
            <input type={'radio'} name={`stbs-${id}`} id={`t1-${id}`} defaultChecked/>
            <input type={'radio'} name={`stbs-${id}`} id={`t2-${id}`}/>
            <label htmlFor={`t1-${id}`}>{label1}</label>
            <label htmlFor={`t2-${id}`}>{label2}</label>
            <div className={'panel panel-1'}>{inf01}</div>
            <div className={'panel panel-2'}>{inf02}</div>
        </div>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.INF01.error_id: {
            return (
                <>
                    <ResultText>
                        The following structure geometry data is extracted from the model files. They are used for
                        relevant
                        checks, comparisons, and plots.
                        <EmptyLine/>
                    </ResultText>
                    {
                        row.data?.map(r => {
                            if (r.type === 'Bridge') {
                                return (
                                    <>
                                        <BridgeTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            } else if (r.type === 'Culvert') {
                                return (
                                    <>
                                        <CulvertTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            }
                        })
                    }
                    <EmptyLine height={16}/>
                    <div style={{fontSize: '8pt', paddingLeft: 8}}>
                        <div><SuperText text={'1'}/> XS Ineff is not defined. Start Station is used for
                            calculation.
                        </div>
                        <div><SuperText text={'2'}/> XS Ineff is not defined. End Station is used for
                            calculation.
                        </div>
                    </div>
                </>
            )
        }
        case MessageCodes.Internal.INF02.error_id: {
            return (
                <>
                    <ResultText>
                        Structure information table extracted from the model files.
                    </ResultText>
                    <EmptyLine/>
                    {
                        row.data?.map(r => {
                            if (r.type === 'Bridge') {
                                return (
                                    <>
                                        <BridgeInfoTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            } else if (r.type === 'Culvert') {
                                return (
                                    <>
                                        <CulvertInfoTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            } else if (r.type === 'Inline Structure') {
                                return (
                                    <>
                                        <InlineStructureInfoTable r={r}/>
                                        <EmptyLine height={12}/>
                                    </>
                                )
                            }
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.ST12.error_id: {
            return (
                <>
                    <ResultText>
                        The upstream and downstream abutment slopes (H:V) are tabulated at the following {row?.data?.length} bridges. Inconsistencies are highlighted in red text.
                    </ResultText>
                    <EmptyLine/>
                    {
                        row?.data?.map(r => {
                            const usLen = Math.max(r?.abutment_left?.us?.length || 0, r?.abutment_right?.us?.length || 0)
                            const dsLen = Math.max(r?.abutment_left?.ds?.length || 0, r?.abutment_right?.ds?.length || 0)

                            const usRows = []
                            for (let i = 0; i < usLen; i++) {
                                usRows.push([r?.abutment_left?.us?.[i], r?.abutment_right?.us?.[i]])
                            }
                            const dsRows = []
                            for (let i = 0; i < dsLen; i++) {
                                dsRows.push([r?.abutment_left?.ds?.[i], r?.abutment_right?.ds?.[i]])
                            }

                            const renderRow = (pair, idx, sideLabel, sideLen) => (
                                <ResultRow>
                                    {idx === 0 && (<ResultBodyCell rowSpan={sideLen}>{sideLabel}</ResultBodyCell>)}
                                    <ResultBodyCell style={{
                                        width: HecRasHelper.getWidth(8),
                                        textAlign: 'end'
                                    }}>{pair[0]?.station}</ResultBodyCell>
                                    <ResultBodyCell style={{
                                        width: HecRasHelper.getWidth(8),
                                        textAlign: 'end'
                                    }}>{pair[0]?.elev}</ResultBodyCell>
                                    <ResultBodyCell style={{
                                        width: HecRasHelper.getWidth(8),
                                        textAlign: 'end',
                                        color: pair[0]?.mark_red ? 'red' : ''
                                    }}>{pair[0]?.slope?.toFixed(2)}</ResultBodyCell>
                                    <ResultBodyCell style={{
                                        width: HecRasHelper.getWidth(8),
                                        textAlign: 'end'
                                    }}>{pair[1]?.station}</ResultBodyCell>
                                    <ResultBodyCell style={{
                                        width: HecRasHelper.getWidth(8),
                                        textAlign: 'end'
                                    }}>{pair[1]?.elev}</ResultBodyCell>
                                    <ResultBodyCell style={{
                                        width: HecRasHelper.getWidth(8),
                                        textAlign: 'end',
                                        color: pair[1]?.mark_red ? 'red' : ''
                                    }}>{pair[1]?.slope?.toFixed(2)}</ResultBodyCell>
                                </ResultRow>
                            )

                            return (
                                <>
                                    <ResultTable>
                                        <ResultHeader>
                                            <ResultRow>
                                                <ResultHeaderCell rowSpan={2} style={{
                                                    width: HecRasHelper.getWidth(12),
                                                    textAlign: 'start'
                                                }}>
                                                    Bridge at <CheckCSName csName={r?.cross_section}/>
                                                </ResultHeaderCell>
                                                <ResultHeaderCell colSpan={3} style={{
                                                    textAlign: 'center',
                                                    width: HecRasHelper.getWidth(24)
                                                }}>Left</ResultHeaderCell>
                                                <ResultHeaderCell colSpan={3} style={{
                                                    textAlign: 'center',
                                                    width: HecRasHelper.getWidth(24)
                                                }}>Right</ResultHeaderCell>
                                            </ResultRow>
                                            <ResultRow>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Station</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Elevation</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Slope</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Station</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Elevation</ResultHeaderCell>
                                                <ResultHeaderCell style={{
                                                    textAlign: 'end',
                                                    width: HecRasHelper.getWidth(8)
                                                }}>Slope</ResultHeaderCell>
                                            </ResultRow>
                                        </ResultHeader>
                                        <ResultBody>
                                            {usRows.map((pair, idx) => renderRow(pair, idx, 'US', usLen))}
                                            {dsRows.map((pair, idx) => renderRow(pair, idx, 'DS', dsLen))}
                                        </ResultBody>
                                    </ResultTable>
                                    <EmptyLine/>
                                </>
                            )
                        })
                    }
                </>
            )
        }
        case MessageCodes.Internal.ST13.error_id: {
            return (
                <>
                    <ResultText>
                        The upstream invert elevation is lower than the downstream invert elevation at the following {row?.data?.length} culverts.
                    </ResultText>
                    <EmptyLine/>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>RS</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>Culvert</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(9)}}>US</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(9)}}>DS</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={r?.cross_section}/>
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{r?.culvert_name}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r?.us_invert}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r?.ds_invert}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r?.slope?.toFixed(4)}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.ST14.error_id: {
            const threshold = row?.data?.[0]?.threshold || 0.02;
            return (
                <>
                    <ResultText>
                        The culvert slope is more than {threshold} at the following {row?.data?.length} culverts.
                    </ResultText>
                    <EmptyLine/>
                    <ResultTable >
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>RS</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(12)}}>Culvert</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(9)}}>US</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(9)}}>DS</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <CheckCSName csName={r?.cross_section}/>
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{r?.culvert_name}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r?.us_invert}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r?.ds_invert}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r?.slope?.toFixed(4)}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.ST15.error_id: {
            return (
                <>
                    <ResultText>
                        The upstream and downstream bridge opening widths are not consistent at the following {row?.data?.length} bridges.
                    </ResultText>
                    <EmptyLine/>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{textAlign: 'left', width: HecRasHelper.getWidth(14)}}>
                                    Bridge Structure
                                </ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>
                                    Opening Width
                                </ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(13)}}>US</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(13)}}>DS</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            RS <CheckCSName csName={r?.cross_section}/>
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: 'red'}}>{r?.us_bow}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', color: 'red'}}>{r?.ds_bow}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}